// src/router.js

import { createRouter, createWebHistory } from 'vue-router'

// Import your components here
import DataFetcher from './views/DataFetcher.vue';
import BackendLogin from './views/BackendLogin.vue';
import BackendLogout from './views/BackendLogout.vue';
import CourseList from './views/CourseList.vue';
import SignupView from './views/SignupView.vue';
import HomeView from './views/HomeView.vue';
import MyCourse from './views/MyCourse.vue';
import MyAttendance from './views/MyAttendance.vue';
import NoticeView from './views/NoticeView.vue';
import GuildLine from './views/GuildLine.vue';
import StudentInfo from './views/StudentInfo.vue';
import ParentInfo from './views/ParentInfo.vue';
import CoursePhoto from '../../share-source/src/views/CoursePhoto.vue';

const routes = [
  {
    path: '/data-fetcher',
    name: 'DataFetcher',
    component: DataFetcher
  },
  {
    path: '/backend-login',
    name: 'BackendLogin',
    component: BackendLogin
  },
  {
    path: '/backend-logout',
    name: 'BackendLogout',
    component: BackendLogout
  },
  {
    path: '/course-list',
    name: 'CourseList',
    component: CourseList
  },
  {
    path: '/signup-view/by-course/:courseId',
    name: 'SignupViewByCourse',
    component: SignupView
  },
  {
    path: '/signup-view/by-id/:signupId',
    name: 'SignupViewById',
    component: SignupView
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/my-course/:status?',
    name: 'MyCourse',
    component: MyCourse
  },
  {
    path: '/my-attendance/:student_id/:date?',
    name: 'MyAttendance',
    component: MyAttendance
  },
  {
    path: '/notice',
    name: 'Notice',
    component: NoticeView
  },
  {
    path: '/guildline',
    name: 'GuildLine',
    component: GuildLine
  },
  {
    path: '/',
    name: 'Root',
    component: BackendLogin
  },
  {
    path: '/student-info/:id?',
    name: 'StudentInfo',
    component: StudentInfo
  },
  {
    path: '/parent-info/:id?',
    name: 'ParentInfo',
    component: ParentInfo
  },
  {
    path: '/course-photo/:id/:name',
    name: 'CoursePhoto',
    component: CoursePhoto
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
